<wbo-search-page [autoRefreshInterval]="25000" [searchOnOpen]="false">
    <fui-page-header-nav>
        <fui-pill-form-context>
            <wbo-location-single-select-edit-control *ngIf="showLocation"
                                                     [(ngModel)]="itemAvailabilityOutletGroupId"
                                                     (onSelect)="itemAvailabilityLocationSelected()"
                                                     [allowClearSelectionOption]="false"
                                                     label="wbo.web-ordering-item-availability.search.field.outletGroupId.label"
                                                     placeholder="wbo.web-ordering-item-availability.search.field.outletGroupId.placeholder">
            </wbo-location-single-select-edit-control>
        </fui-pill-form-context>
    </fui-page-header-nav>
    <wbo-search-form>
        <wbo-search-form-fields>
            <wbo-search-form-field *ngIf="!requiresLocationSelection" field="availability">
                <wbo-multi-select-search-control>
                    <wbo-select-options>
                        <wbo-select-option [value]="ItemAvailability.AVAILABLE"
                                           label="wbo.web-ordering-item-availability.option.availability.available"></wbo-select-option>
                        <wbo-select-option [value]="ItemAvailability.SOLD_OUT"
                                           label="wbo.web-ordering-item-availability.option.availability.soldOut"></wbo-select-option>
                        <wbo-select-option [value]="ItemAvailability.SOLD_OUT_TODAY"
                                           label="wbo.web-ordering-item-availability.option.availability.soldOutToday"></wbo-select-option>
                        <wbo-select-option [value]="ItemAvailability.NOT_SOLD"
                                           label="wbo.web-ordering-item-availability.option.availability.notSold"></wbo-select-option>
                    </wbo-select-options>
                </wbo-multi-select-search-control>
            </wbo-search-form-field>
            <wbo-search-form-field field="name">
                <wbo-simple-search-control></wbo-simple-search-control>
            </wbo-search-form-field>
            <wbo-search-form-field field="customObjectId">
                <wbo-custom-object-multi-select-search-control [productLineContext]="true"></wbo-custom-object-multi-select-search-control>
            </wbo-search-form-field>
        </wbo-search-form-fields>
    </wbo-search-form>
    <wbo-search-grid>
        <wbo-search-grid-header>
            <fui-message-label *ngIf="requiresLocationSelection"
                               [title]="'wbo.web-ordering-item-availability.message.noLocationTitle'"
                               class="search-grid-title">
            </fui-message-label>
        </wbo-search-grid-header>
        <wbo-column field="pinned" [width]="10">
            <ng-template cellTemplate let-dataItem="dataItem">
                <div class="pinned-column" (click)="pinItem(dataItem)"
                     [ngClass]="{'active': !requiresLocationSelection}">
                    <fui-icon [icon]="'pin'" [width]="15" [height]="15" class="pinned-column-icon"
                              *ngIf="savingPinSellableId !== dataItem.sellableId"
                              [ngClass]="{'pinned': dataItem.pinned}"></fui-icon>
                    <fui-spinning-loader [height]="15" [width]="15"
                                         *ngIf="savingPinSellableId === dataItem.sellableId"></fui-spinning-loader>
                </div>
            </ng-template>
        </wbo-column>
        <wbo-column field="name"></wbo-column>
        <wbo-column field="availability" [sortable]="false" [width]="200">
            <ng-template cellTemplate let-dataItem="dataItem">
                <div class="availability-column">
                    <wbo-single-select-edit-control [value]="getAvailabilityValue(dataItem)"
                                                    *ngIf="!requiresLocationSelection"
                                                    class="availability-column-select"
                                                    [ngClass]="{'set': dataItem.notSold || dataItem.productCount != undefined}"
                                                    [allowClearSelectionOption]="false"
                                                    (onSelect)="updateAvailability(dataItem, $event.value)">
                        <wbo-select-options>
                            <wbo-select-option [value]="ItemAvailability.AVAILABLE"
                                               [label]="dataItem.productCount > 0 ? 'wbo.web-ordering-item-availability.option.availability.availableCountDown' : 'wbo.web-ordering-item-availability.option.availability.available'"
                                               [labelParams]="{'countdown': dataItem.productCount}"></wbo-select-option>
                            <wbo-select-option [value]="ItemAvailability.SOLD_OUT"
                                               label="wbo.web-ordering-item-availability.option.availability.soldOut"></wbo-select-option>
                            <wbo-select-option [value]="ItemAvailability.SOLD_OUT_TODAY"
                                               label="wbo.web-ordering-item-availability.option.availability.soldOutToday"></wbo-select-option>
                            <wbo-select-option [value]="ItemAvailability.NOT_SOLD"
                                               label="wbo.web-ordering-item-availability.option.availability.notSold"></wbo-select-option>
                        </wbo-select-options>
                    </wbo-single-select-edit-control>
                    <div class="availability-column-spinner" *ngIf="savingAvailabilitySellableId !== dataItem.sellableId"></div>
                    <fui-spinning-loader [height]="26" [width]="26"
                                         *ngIf="savingAvailabilitySellableId === dataItem.sellableId"></fui-spinning-loader>
                </div>
            </ng-template>
        </wbo-column>
        <wbo-column field="productCount" [hideable]="true" [enabled]="false">
            <ng-template cellTemplate let-dataItem="dataItem">
                <div *ngIf="!requiresLocationSelection" class="countdown-column"
                     (click)="editCountdown(dataItem)">
                    <fui-action class="countdown-column-control">
                        <fui-icon [width]="14" [height]="14"
                                  [icon]="'chevron-down'"></fui-icon>
                    </fui-action>
                    <div *ngIf="!dataItem.notSold" class="countdown-column-text"
                         [ngClass]="{'set': dataItem.productCount > 0 || dataItem.resetAtStartOfDay}">
                        {{dataItem.productCount > 0 ? dataItem.productCount : ''}} <span
                        *ngIf="dataItem.resetAtStartOfDay">{{(dataItem.restockLevel ? 'wbo.web-ordering-item-availability.message.restockSet' : 'wbo.web-ordering-item-availability.message.restockSetToUnlimited') | translate: {restockLevel: dataItem.restockLevel} }}</span>
                    </div>
                </div>
            </ng-template>
        </wbo-column>
    </wbo-search-grid>
</wbo-search-page>
